export { TextOverflow } from './TextOverflow';
